import TextInput from "../../components/ui/input/TextInput";
import SectionHeader from "../../components/ui/labels/SectionHeader";
import QuestionSection from "../contractorAudit/auditQuestions/QuestionSection";
import useToolInventory from "./useToolInventory";
import { initialState } from "./splicerAuditReducer";
import TextArea from "../../components/ui/input/TextArea";
import ToolInventoryCard from "../../components/ui/containers/ToolInventoryCard";
import useQuestions from "../../hooks/useAuditQuestions";

const ToolInventory = ({ state, dispatch, ACTIONS }) => {
  const { splicerToolHeaders, splicerToolQuestions } = useQuestions();
  const {
    bareFiberAdapterMakeModelHandler,
    bufferTubeMakeModelHandler,
    conesMakeModelHandler,
    coreTubeEntryKitHandler,
    drillHandler,
    exfoLaunchBagMakeModelHandler,
    fiberMakeModelHandler,
    fiberOpticDropSlitterHandler,
    fiberSerialHandler,
    fishTapeMakeModelHandler,
    fsMachineRibbonMakeModelHandler,
    fsMachineRibbonSerialHandler,
    fsMachineSingleMakeModelHandler,
    fsMachineSingleSerialHandler,
    handToolsMakeModelHandler,
    harnessMakeModelHandler,
    ladder28ftMakeModelHandler,
    ladder6ftMakeModelHandler,
    midSpanSplitterToolHandler,
    opticalLossMakeModel1Handler,
    opticalLossMakeModel2Handler,
    opticalLossSerial1Handler,
    opticalLossSerial2Handler,
    otdrMakeModelHandler,
    otdrSerialHandler,
    safetyVestAndHardHatMakeModelHandler,
    signAndHolderMakeModelHandler,
    splicerTentMakeModelHandler,
    splicingTableMakeModelHandler,
    toolNotesChangeHandler,
    toolsetMakeModelHandler,
    trailerTypeAndNumHandler,
    vehicleNumberHandler,
    vehicleTypeHandler,
  } = useToolInventory({
    dispatch,
    ACTIONS,
  });

  return (
    <>
      <SectionHeader text="Tool Inventory" />
      <QuestionSection title={splicerToolHeaders.splicerInfo}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.vehicleNumber}
            onChange={vehicleNumberHandler}
            value={state.vehicleNumber}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.vehicleType}
            onChange={vehicleTypeHandler}
            value={state.vehicleType}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.trailerTypeAndNum}
            onChange={trailerTypeAndNumHandler}
            value={state.trailerTypeAndNum}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <QuestionSection title={splicerToolHeaders.otdr}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.otdrMakeModel}
            onChange={otdrMakeModelHandler}
            value={state.otdrMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.otdrSerial}
            onChange={otdrSerialHandler}
            value={state.otdrSerial}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <QuestionSection title={splicerToolHeaders.fusionSplice}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.fsMachineSingleMakeModel}
            onChange={fsMachineSingleMakeModelHandler}
            value={state.fsMachineSingleMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.fsMachineSingleSerial}
            onChange={fsMachineSingleSerialHandler}
            value={state.fsMachineSingleSerial}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.fsMachineRibbonMakeModel}
            onChange={fsMachineRibbonMakeModelHandler}
            value={state.fsMachineRibbonMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.fsMachineRibbonSerial}
            onChange={fsMachineRibbonSerialHandler}
            value={state.fsMachineRibbonSerial}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <QuestionSection title={splicerToolHeaders.fiberIdentifier}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.fiberMakeModel}
            onChange={fiberMakeModelHandler}
            placeholder={initialState.fiberMakeModel}
            value={state.fiberMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.fiberSerial}
            onChange={fiberSerialHandler}
            value={state.fiberSerial}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <QuestionSection title={splicerToolHeaders.opticalLoss}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.opticalLossMakeModel1}
            onChange={opticalLossMakeModel1Handler}
            placeholder={initialState.opticalLossMakeModel1}
            value={state.opticalLossMakeModel1}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.opticalLossSerial1}
            onChange={opticalLossSerial1Handler}
            placeholder={initialState.opticalLossSerial1}
            value={state.opticalLossSerial1}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.opticalLossMakeModel2}
            onChange={opticalLossMakeModel2Handler}
            placeholder={initialState.opticalLossMakeModel2}
            value={state.opticalLossMakeModel2}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.opticalLossSerial2}
            onChange={opticalLossSerial2Handler}
            placeholder={initialState.opticalLossSerial2}
            value={state.opticalLossSerial2}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <QuestionSection title={splicerToolHeaders.ladders}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.ladder28ftMakeModel}
            onChange={ladder28ftMakeModelHandler}
            placeholder={initialState.ladder28ftMakeModel}
            value={state.ladder28ftMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.ladder6ftMakeModel}
            onChange={ladder6ftMakeModelHandler}
            placeholder={initialState.ladder6ftMakeModel}
            value={state.ladder6ftMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <QuestionSection title={splicerToolHeaders.metronetSupply}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.conesMakeModel}
            onChange={conesMakeModelHandler}
            placeholder={initialState.conesMakeModel}
            value={state.conesMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.safetyVestAndHardHatMakeModel}
            onChange={safetyVestAndHardHatMakeModelHandler}
            placeholder={initialState.safetyVestAndHardHatMakeModel}
            value={state.safetyVestAndHardHatMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.harnessMakeModel}
            onChange={harnessMakeModelHandler}
            placeholder={initialState.harnessMakeModel}
            value={state.harnessMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.fishTapeMakeModel}
            onChange={fishTapeMakeModelHandler}
            placeholder={initialState.fishTapeMakeModel}
            value={state.fishTapeMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.handToolsMakeModel}
            onChange={handToolsMakeModelHandler}
            placeholder={initialState.handToolsMakeModel}
            value={state.handToolsMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <QuestionSection title={splicerToolHeaders.misc}>
        <ToolInventoryCard>
          <TextInput
            label={splicerToolQuestions.drill}
            onChange={drillHandler}
            placeholder={initialState.drill}
            value={state.drill}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.splicingTableMakeModel}
            onChange={splicingTableMakeModelHandler}
            placeholder={initialState.splicingTableMakeModel}
            value={state.splicingTableMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.bufferTubeMakeModel}
            onChange={bufferTubeMakeModelHandler}
            placeholder={initialState.bufferTubeMakeModel}
            value={state.bufferTubeMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.splicerTentMakeModel}
            onChange={splicerTentMakeModelHandler}
            placeholder={initialState.splicerTentMakeModel}
            value={state.splicerTentMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.foDropSlitterMakeModel}
            onChange={fiberOpticDropSlitterHandler}
            placeholder={initialState.foDropSlitterMakeModel}
            value={state.foDropSlitterMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.midspanSplitterMakeModel}
            onChange={midSpanSplitterToolHandler}
            placeholder={initialState.midspanSplitterMakeModel}
            value={state.midspanSplitterMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.coreTubeEntryKitMakeModel}
            onChange={coreTubeEntryKitHandler}
            placeholder={initialState.coreTubeEntryKitMakeModel}
            value={state.coreTubeEntryKitMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.toolsetMakeModel}
            onChange={toolsetMakeModelHandler}
            placeholder={initialState.toolsetMakeModel}
            value={state.toolsetMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.signAndHolderMakeModel}
            onChange={signAndHolderMakeModelHandler}
            placeholder={initialState.signAndHolderMakeModel}
            value={state.signAndHolderMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.bareFiberAdapterMakeModel}
            onChange={bareFiberAdapterMakeModelHandler}
            placeholder={initialState.bareFiberAdapterMakeModel}
            value={state.bareFiberAdapterMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
          <TextInput
            label={splicerToolQuestions.exfoLaunchBagMakeModel}
            onChange={exfoLaunchBagMakeModelHandler}
            placeholder={initialState.exfoLaunchBagMakeModel}
            value={state.exfoLaunchBagMakeModel}
            type="text"
            autocomplete="false"
            required={true}
          />
        </ToolInventoryCard>
      </QuestionSection>
      <TextArea
        label={splicerToolQuestions.toolNotes}
        placeholder={splicerToolQuestions.toolNotes}
        identifier={"toolNotes"}
        onChange={toolNotesChangeHandler}
        value={state.toolNotes}
      />
    </>
  );
};

export default ToolInventory;
